export const historize = ({ customer, changes }) => {

    if (!customer || !changes) {
        return null;
    }

    const keys = [
        ...new Set(Object.keys(customer)
            .concat(Object.keys(changes)))
    ];

    const updates = {};
    for (const key of keys) {

        if (customer[key] === changes[key]) {
            continue;
        }

        updates[key] = {
            old: customer[key] || null,
            new: changes[key] || null
        }
    }

    return updates;
}
